<template>
  <div>
    <transition name="el-fade-in-linear">
      <table class="table" v-if="latestOrders.length">
        <thead>
          <tr>
            <th>Datum</th>
            <th>Lager</th>
            <th>Lieferant</th>
            <th>Status</th>
            <th>Produkte</th>
            <th>&nbsp;</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="order in latestOrders" :key="order.id">
            <td>
              <router-link :to="`/orders/${order.id}`">
              {{ order.date ? order.date : order.created_at | date }}
            </router-link>
            </td>
            <td>
              <router-link :to="`/warehouses/${order.warehouse_id}/products`">
                {{ order.warehouse.name }}
              </router-link>
            </td>
            <td>
              <router-link :to="`/suppliers/${order.supplier_id}`">
                {{ order.supplier.name }}
              </router-link></td>
            <td>
              <span v-if="order.status === 'ordered'">
                Bestellt
              </span>
              <span v-else-if="order.status === 'open'">
                Offen
              </span>
              <span v-else-if="order.status === 'finished'">
                Abgeschlossen
              </span>
              <span v-else-if="order.status === 'waiting'">
                Wartet auf Freigabe
              </span>
              <span v-else-if="order.status === 'problem'">
               Problem
              </span>
              <span v-else-if="order.status === 'incomplete'">
               Unvollständig geliefert
              </span>
              <span v-else-if="order.status === 'storno'">
               Storniert
              </span>
            </td>
            <td @click="showOrderProductsDialog(order.products)" class="text-center" style="cursor: pointer;">
              <i class="fas fa-boxes" aria-hidden="true"></i>
            </td>
          </tr>
        </tbody>
      </table>
    </transition>
    <p v-if="!latestOrders.length">Keine Bestellungen</p>
    <order-products-dialog
      :show="showProducts"
      :order-products="orderProducts"
      @close="showProducts = false"
    />
  </div>

</template>

<script>
import OrderProductsDialog from '../Orders/order-products-dialog'

export default {
  props: {
    latestOrders : [],
  },
  components: {
    OrderProductsDialog
  },
  data() {
    return {
      showProducts: false,
      orderProducts: []
    }
  },
  methods: {
    showOrderProductsDialog(orderProducts) {
      this.orderProducts = orderProducts;
      this.showProducts = true;
    }
  }
}
</script>

<style>
</style>
